import * as React from 'react';
import styled from 'styled-components';
import { defaultTheme } from '@mindlercare/ui-web/src/shared/constants';
import type { Author } from '../types';

export interface MessageBubbleProps {
  role: Author;
  children: React.ReactNode;
}

const StyledBubble = styled.div<{ $role: Author }>`
  position: relative;
  max-width: 78%;
  border-radius: 14px;
  padding: 4px 14px;
  font-size: 15px;
  line-height: 1.55;
  border: 1px solid ${defaultTheme.COLORS.GRAY_BLACK_6};
  transition: transform 200ms ease, box-shadow 200ms ease;
  color: ${props => props.$role === 'system' ? defaultTheme.COLORS.GRAY_SYSTEM : defaultTheme.COLORS.GRAY_BLACK};

  ${props => props.$role === 'user' && `
    background: ${defaultTheme.COLORS.GRAY_LIGHT};
    border-top-right-radius: 6px;
  `}

  ${props => props.$role === 'model' && `
    background: transparent;
    border: none;
    padding: 0;
    border-top-left-radius: 0;
    box-shadow: none;
  `}

  ${props => props.$role === 'system' && `
    background: ${defaultTheme.COLORS.WARM_LIGHT};
    border-style: dashed;
  `}
`;

export const MessageBubble: React.FC<MessageBubbleProps> = ({ role, children }) => {
  return (
    <StyledBubble $role={role} className="bubble">
      {children}
    </StyledBubble>
  );
};
